import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faRotate } from "@fortawesome/free-solid-svg-icons";
import styles from "./SyncStatusBanner.module.css";
import { subscribe, flush } from "../services/workoutOutbox";

/**
 * SyncStatusBanner
 *
 * Torna visível o que antes era invisível: séries registradas no aparelho
 * que ainda não chegaram no servidor (achado P0 da revisão mobile de
 * 06/09/2026 — o save falhava calado e o aluno só descobria depois, com o
 * treino zerado pelo fechamento automático).
 *
 * Estados:
 *   - fila vazia            → não renderiza nada
 *   - enviando, sem falha   → "Salvando treino…" (discreto, sem alarme)
 *   - com falha pendente    → "N registro(s) aguardando conexão" + botão
 *                             de tentar agora
 *
 * Deliberadamente NÃO é um erro vermelho: o dado está seguro no aparelho,
 * a mensagem tranquiliza em vez de assustar no meio do treino.
 */
export default function SyncStatusBanner() {
  const [status, setStatus] = useState({ pending: 0, syncing: false, failing: false });

  useEffect(() => subscribe(setStatus), []);

  if (!status.pending) return null;

  const waiting = status.failing && !status.syncing;

  return (
    <div
      className={`${styles.banner} ${waiting ? styles.waiting : styles.syncing}`}
      role="status"
      aria-live="polite"
    >
      <FontAwesomeIcon
        icon={waiting ? faCloudArrowUp : faRotate}
        className={waiting ? undefined : styles.spin}
      />
      {waiting ? (
        <>
          <span>
            {status.pending} registro{status.pending > 1 ? "s" : ""} salvo
            {status.pending > 1 ? "s" : ""} no aparelho, aguardando conexão
          </span>
          <button type="button" className={styles.retryBtn} onClick={() => flush()}>
            Tentar agora
          </button>
        </>
      ) : (
        <span>Salvando treino…</span>
      )}
    </div>
  );
}
